import { render, staticRenderFns } from "./AdminFeaturedTemplates.vue?vue&type=template&id=a022a8bc&scoped=true"
import script from "./AdminFeaturedTemplates.vue?vue&type=script&lang=ts"
export * from "./AdminFeaturedTemplates.vue?vue&type=script&lang=ts"
import style0 from "./AdminFeaturedTemplates.vue?vue&type=style&index=0&id=a022a8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a022a8bc",
  null
  
)

export default component.exports